import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { Col, Container, Row } from 'reactstrap'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { faFaceParty, faPaperPlane } from '@fortawesome/pro-duotone-svg-icons'
import {
  BootstrapTextInput,
  BootstrapDateTimeInput,
  FormCard,
  TypeaheadMultiInput,
} from '../components/forms'
import ResponsiveIconSubmitButton from '../components/ResponsiveIconSubmitButton'
import axios from 'axios'
import { apiUrl } from '../utils/url'
import { getJwt } from '../utils/jwt'
import { useAllQuery } from '../utils/hooks/reactQuery/queries'
import { getFormattedDateTimeString } from '../utils/dateTimeFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AlertSchema = Yup.object().shape({
  message: Yup.string()
    .max(100, 'Message exceeds max character count')
    .required('Message is required'),
  title: Yup.string()
    .max(48, 'Title exceeds max character count')
    .required('Title is required'),
  link: Yup.string()
    .url('Link should be a valid URL')
    .required('Link is required'),
  listIds: Yup.array()
    .of(Yup.number())
    .min(1, 'At least one list is required')
    .required('Lists is required'),
  suppressionListIds: Yup.array().of(Yup.number()),
  schedule: Yup.date('Schedule must be a date').required(
    'Schedule is required',
  ),
})

function TotdMarketingPush() {
  const [alreadySent, setAlreadySent] = useState(false)
  const { data: lists = [] } = useAllQuery('iterable-lists')

  const handleSubmit = async (values, { setSubmitting }) => {
    const toastId = toast.loading('Sending marketing push...')

    const axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getJwt()}`,
      },
    }

    const pushName = `${getFormattedDateTimeString(
      false,
      new Date(values.schedule),
    )}_TOTD_APP_MARKETING_PUSH`

    const data = {
      name: pushName,
      title: values.title,
      message: values.message,
      link: values.link,
      listIds: values.listIds,
      suppressionListIds: values.suppressionListIds,
      sendAt: values.schedule,
    }

    try {
      const response = await axios.post(
        `${apiUrl}iterable-campaigns/send-totd-native-push`,
        data,
        axiosConfig,
      )
      console.log(response)
      toast.update(toastId, {
        render: 'Successfully sent push notification!',
        type: 'success',
        isLoading: false,
        autoClose: 1500,
      })
      setAlreadySent(true)
      setSubmitting(false)
    } catch (error) {
      console.error(error)
      toast.update(toastId, {
        render: 'Could not send push notification...',
        type: 'error',
        isLoading: false,
        autoClose: 1500,
      })
      setSubmitting(false)
    }
  }

  if (alreadySent) {
    return (
      <Container fluid className="text-center">
        <Row>
          <Col>
            <h2>TOTD Marketing Push</h2>
          </Col>
        </Row>
        <Row className="my-5">
          <Col>
            <FontAwesomeIcon
              icon={faFaceParty}
              size="9x"
              className="text-cpblue-500"
              spin
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <p>Message sent! Please refresh page to send a new message.</p>
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <Container fluid>
      <FormCard
        breadcrumbLink="/dashboard"
        breadcrumbLabel="Dashboard"
        breadcrumbItem="TOTD Marketing Push"
      >
        <Formik
          initialValues={{
            message: '',
            title: '',
            link: '',
            listIds: [],
            suppressionListIds: [],
            schedule: '',
          }}
          validationSchema={AlertSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, isValid, values, setFieldValue }) => (
            <Form>
              <Row>
                <BootstrapTextInput
                  required
                  fullWidth
                  maxLength={48}
                  label="Title"
                  id="title"
                  name="title"
                  placeholder="Title"
                />
                <BootstrapTextInput
                  required
                  fullWidth
                  isTextArea
                  maxLength={100}
                  label="Message"
                  id="message"
                  name="message"
                  placeholder="Message"
                />
                <BootstrapTextInput
                  required
                  fullWidth
                  label="Link"
                  id="link"
                  name="link"
                  placeholder="Link"
                />
                <TypeaheadMultiInput
                  required
                  label="Lists"
                  id="listIds"
                  name="listIds"
                  placeholder="Lists"
                  options={lists}
                  objects
                  labelKey="name"
                  valueKey="id"
                />
                <TypeaheadMultiInput
                  label="Suppression Lists"
                  id="suppressionListIds"
                  name="suppressionListIds"
                  placeholder="Suppression Lists"
                  options={lists}
                  objects
                  labelKey="name"
                  valueKey="id"
                />
                <BootstrapDateTimeInput
                  required
                  fullWidth
                  label="Schedule"
                  id="schedule"
                  name="schedule"
                />
              </Row>
              <ResponsiveIconSubmitButton
                disabled={isSubmitting || !isValid}
                icon={faPaperPlane}
              >
                Send
              </ResponsiveIconSubmitButton>
            </Form>
          )}
        </Formik>
      </FormCard>
    </Container>
  )
}

export default TotdMarketingPush
